"use strict";

const MuniManholeDataListController = function () {
  var inited = false;
  var config = null;

  var init = function (reInitialize = false) {
    if (inited && !reInitialize) {
      render();
    } else {
      inited = true;
      config = {
        prepareDataCallback: _prepareMuniManhole,
        template: "list/muniManholeDataList.njk",
        layerName: "muniManhole",
      };
      DataList.init(config);
      initialRender();
      loadListeners();
      DataList.loadDomListeners();
      DataList.loadDomListeners([{ target: ".open-fact-sheet", callback: openFactSheet }]);
    }
  };

  var loadListeners = function () {
    $(".data-list-container").off("click", ".map-button");
    $(".data-list-container").on("click", ".map-button", showMarkerOnMap);

    $(".data-list-container").off("click", ".open-hard-asset-inventory");
    $(".data-list-container").on(
      "click",
      ".open-hard-asset-inventory",
      HardAssetInventoryModalController.onOpenInventoryClick,
    );
  };

  var openFactSheet = function () {
    const id = DataList.getDataFromRow($(this)).id;
    UrlRoutes.go("manhole-fact-sheet", { id });
    Analytics.sendDataListEvent("open_factsheet", "manholes");
  };

  var showMarkerOnMap = function () {
    var $tr = $(this).parents("tr");
    var id = $tr.data("id");

    MapFunctions.openPopupById(id);
    const mapButtonContainer = $(this).parents("td");
    DataList.addAnalyticsToMapIconOnAddress(mapButtonContainer.hasClass("address-col"));
  };

  var initialRender = function () {
    DataList.setSorting("manholeName", false);
    render();
  };

  var render = function () {
    DataList.render(config);
  };

  var _prepareMuniManhole = function (muniManholes) {
    for (const manhole of muniManholes) {
      manhole.lastInspectionDate = manhole.routine[manhole.routine.length - 1];
      manhole.lastInspectionDisplayDate = manhole.lastInspectionDate
        ? DateTime.dateToGroupDisplayDate(manhole.lastInspectionDate)
        : null;
    }
    sortMuniManholesBy(muniManholes);

    return {
      rows: muniManholes,
      options: {},
    };
  };

  var sortMuniManholesBy = function (muniManholes) {
    const alphaSorter = SortUtilities.alphaSorter;

    var sortersDict = {
      manholeName: alphaSorter,
      address: alphaSorter,
      manholeType: alphaSorter,
      coverShape: alphaSorter,
      cof: SortUtilities.cofSorter,
      lastInspectionDate: DateTime.dateComparator,
    };
    DataList.sortWithDict(muniManholes, sortersDict);
  };

  return {
    init,
  };
};

module.exports = MuniManholeDataListController();

const DataList = require("../mapFunctions/dataList");
const SortUtilities = require("../general/sortUtilities.js");
const MapFunctions = require("../mapFunctions/mapFunctions.js");
const UrlRoutes = require("../routes/urlRoutes");
const Analytics = require("../general/analytics");
const HardAssetInventoryModalController = require("./hardAssetInventoryModalController");
const DateTime = require("../dateTime");
